module.exports = __webpack_public_path__ + "static/media/default-longMallProduct.02f38ee5.png";